import { Component, OnInit } from '@angular/core';
import { FormGroup,FormBuilder, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';
import { Image } from '../../../../../images/images'
import { NewsService } from 'src/app/shared/API-Service/services/news.service';
import { KeywordsService } from 'src/app/shared/API-Service/services/keywords.service';
import { IDropdownSettings, } from 'ng-multiselect-dropdown';
import { AngularEditorConfig, AngularEditorModule } from '@kolkov/angular-editor';
import { GovernorateService } from 'src/app/shared/API-Service/services/governorate.service';
import {News} from "../../../../shared/Models/News";
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'app-insert-news',
  templateUrl: './insert-news.component.html',
  styleUrls: ['./insert-news.component.css']
})
export class InsertNewsComponent implements OnInit {
  
  keyword:object [] = [];
  selectedItems:any = [];
  selectedItemsGovernates:any = [];
  dropdownSettings: any = {};
  recordtoupdate: any;
  newsForm : FormGroup;
newsFormData : FormData;
update:boolean = false;
button:boolean = false;
Image: File;
imageLogo: string;
img : string = Image;
Governates:any;
  id: string;
  News: any;
  NewsModel=new News()
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '200px',
    minHeight: '200px',
    maxHeight: 'auto',
    width: '100%',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: 'p', // Ensure 'p' tag is used for paragraphs
    defaultFontName: 'Arial',
    toolbarHiddenButtons: [['subscript', 'superscript'],
    ['link', 'insertImage', 'insertVideo'],
    ['outdent', 'indent']],
    toolbarPosition: 'top',
    sanitize: false, // Disable sanitization
    outline: false
  };
  inactive: boolean=false;
  constructor(public datepipe: DatePipe,private route: ActivatedRoute,private router: Router,private GovernorateService:GovernorateService, private _NewsService:NewsService,private _Router:Router,private _FormBuilder:FormBuilder, 
    private _KeywordsService:KeywordsService, private _DatePipe:DatePipe) { 
      this.imageLogo="../../../../../assets/images/upload.png"

    }

  ngOnInit(): void {
    if (this.route.snapshot.paramMap.get("id")) {
      console.log(this.route.snapshot.paramMap.get("id"))
      this.id =this.route.snapshot.paramMap.get("id") || ''
      this._NewsService.GetNewsByid(this.id).subscribe(async (res:any)=>{
        console.log(res.data);
      this.News=  await res.data;
      console.log(this.News.keywordsNames)
      //   this.newsForm.patchValue({
      //     keywords: this.News.keywordsNames,
      // });
      this.selectedItems=this.News.keywordsNames;
      this.selectedItemsGovernates=this.News.governorates;
      this.inactive=this.News.showInHome;
      this.News.date= this.datepipe.transform(this.News.date, 'yyyy-MM-dd');
      this.imageLogo=environment.ServerImages_URL+'/'+this.News.image
      this.initiate(this.News);
        
      })
      this.update = true;
    } else {
      this.initiate();
      this.update = false;
    }
    this.getkeywords();
    this.GetGovernorate();
    
    this.checkEdit();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'title',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
     
  };
  }
  // editorConfig: AngularEditorConfig = {
  //   editable: true,
  //     spellcheck: true,
  //     height: '300px',
  //     minHeight: '50',
  //     maxHeight: 'auto',
  //     width: 'auto',
  //     minWidth: '0',
  //     translate: 'yes',
  //     enableToolbar: true,
  //     showToolbar: true,
  //     defaultParagraphSeparator: '',
  //     defaultFontName: '',
  //     defaultFontSize: '',
  //     fonts: [
  //       {class: 'arial', name: 'Arial'},
  //       {class: 'times-new-roman', name: 'Times New Roman'},
  //       {class: 'calibri', name: 'Calibri'},
  //       {class: 'comic-sans-ms', name: 'Comic Sans MS'}
  //     ],
  //     customClasses: [
  //     {
  //       name: 'quote',
  //       class: 'quote',
  //     },
  //     {
  //       name: 'redText',
  //       class: 'redText'
  //     },
  //     {
  //       name: 'titleText',
  //       class: 'titleText',
  //       tag: 'h1',
  //     },
  //   ],
  //   uploadWithCredentials: false,
  //   sanitize: true,
  //   toolbarPosition: 'top',
  //   toolbarHiddenButtons: [
  //     ['fontSize','undo',
  //     'redo',
  //     'strikeThrough',
  //     'subscript',
  //     'superscript',
  //     'justifyLeft',
  //     'justifyCenter',
  //     'justifyRight',
  //     'justifyFull',
  //     'indent',
  //     'outdent','insertUnorderedList',
  //     'heading',
  //     'fontName', 'fontSize',
  //     'textColor',
  //     'backgroundColor',
  //     'customClasses',
  //     'insertImage',
  //     'insertVideo',
  //     'insertHorizontalRule',
  //     'removeFormat',
  //     'toggleEditorMode']
      
  //   ]
  // };
  GetGovernorate(){
    this.GovernorateService.GetGovernorate().subscribe(res=>{
      this.Governates=res.data;
    })
  }
  inactiveChange(){
    if(this.inactive){
      this.inactive=false;
    }
    else{
          this.inactive=true;
    }   

  }
  initiate(News?:News){
    this.newsForm = this._FormBuilder.group({
      title: [News?.title||'', Validators.required],
      body: [News?.body||'', Validators.required],
      date: [News?.date||'', Validators.required],
      keywords: [News?.keywordsNames||'', Validators.required],
      videoUrl : [News?.videoUrl||'', [Validators.required , Validators.pattern(`((http|https)://)(www.)[a-zA-Z0-9.]{1,}(/){1}(.*)`)]],
      GovernatesIds:[News?.governoratesIds||'', Validators.required],
    });
  }
  getkeywords(){
    this._KeywordsService.Getkeywords().subscribe((res) => {
      this.keyword = res.data; 
      console.log(this.keyword)
    },(err) => {
     console.log('their is a problem');
    },() => {
     console.log('completed');
    })
   }
   onItemSelect(item: any) {
    
     console.log(this.selectedItems);
 }
 onItemDeSelect(item: any) {
     console.log('onItemDeSelect', item);
     removeItem(item, this.selectedItems);
      
 }
 onSelectAll(items: any) {
     console.log('onSelectAll', items);
 }
 onUnSelectAll(items: any) {
  this.selectedItems = [];
     console.log('onSelectAll', items);
 }
  insertappenddata(){
    this.newsFormData = new FormData();
    this.newsFormData.append("Title", this.newsForm.value.title);
    this.newsFormData.append("Body", this.newsForm.value.body);
    this.newsFormData.append("VideoUrl", this.newsForm.value.videoUrl);
    this.newsFormData.append("date", this.newsForm.value.date);
    this.newsFormData.append("ShowInHome", String(this.inactive) );

    this.selectedItems.forEach(element => {
      this.newsFormData.append("Keywords", element.id);   
      });
      this.selectedItemsGovernates.forEach(element => {
        this.newsFormData.append("GovernoratesIds", element.id);  
      });
    
    this.newsFormData.append("NewsImage", this.Image);
 
  }
  updateappenddata(){
    this.newsFormData = new FormData();
    this.newsFormData.append("Title", this.newsForm.value.title);
    this.newsFormData.append("Body", this.newsForm.value.body);
    this.newsFormData.append("VideoUrl", this.newsForm.value.videoUrl);
    this.newsFormData.append("date", this.newsForm.value.date);
    this.newsFormData.append("ShowInHome", String(this.inactive) );

    this.selectedItems.forEach(element => {
      this.newsFormData.append("Keywords", element.id);   
      });
      this.selectedItemsGovernates.forEach(element => {
        this.newsFormData.append("GovernoratesIds", element.id);  
      });
    this.newsFormData.append("NewsImage", this.Image);
    this.newsFormData.append("Id", this.id);
  }
  checkEdit() {
    this._NewsService.Data.subscribe((res) => {
      if (res != null){
        this.selectedItems = res.keywordsNames;
        this.newsForm = this._FormBuilder.group({
          title: [res.title, Validators.required],
          body: [res.body, Validators.required],
          date: [this._DatePipe.transform(res.date, 'yyyy-MM-dd'), Validators.required],
          keywords: [this.selectedItems],
          videoUrl: [res.videoUrl, [Validators.required , Validators.pattern(`((http|https)://)(www.)[a-zA-Z0-9.]{1,}(/){1}(.*)`)]],
          NewsImage : [res.image]
        });
        this.imageLogo = this.img + res.image;
        console.log(this.imageLogo);
        this.update = true;
        this.recordtoupdate = res ;
      console.log(this.recordtoupdate);
      } else {
        console.log(`not found on data`);
        // this.initiate();
      }
     
    });
  }
      // imgFile
      getLogoUrl(event: any) {
        const reader = new FileReader();
        if (event.target.files && event.target.files.length) {
          const [file] = event.target.files;
          this.Image = event.target.files[0];
          reader.readAsDataURL(file);
          reader.onload = () => {
            this.imageLogo = reader.result as string;
            // this.logoForm?.append("image", this.Image);
          };
        }
      }
      get fc() {
        return this.newsForm.controls;
      }
      onSubmit(){
        this.button = true;
       if(this.update == false && this.newsForm.status == "VALID"){
        
        this.insertappenddata();
        
        this._NewsService.CreateNews(this.newsFormData).subscribe((res) => {
          Swal.fire({
            icon: "success",
            title: "تم الحفظ بنجاح  ",
            showConfirmButton: false,
            timer: 1500,
          });
          this.newsForm.reset();
          this._Router.navigate(['/content/admin/ViewNews']);
        },(err) => {
          Swal.fire({
            icon: 'error',
            title: 'خطأ',
            text:err.message    
          }) 
          this.button = false ;
        }, () => {
          console.log('completed ');
        })
       } else if(this.newsForm.status == "VALID"){
        this.updateappenddata();
        this._NewsService.UpdateNews(this.newsFormData).subscribe((res) => {
          Swal.fire({
            icon: "success",
            title: "تم التعديل بنجاح",
            showConfirmButton: false,
            timer: 1500,
          });
          this.newsForm.reset();
          this._Router.navigate(['/content/admin/ViewNews']);
        },(err) => {
          Swal.fire({
            icon: 'error',
            title: 'خطأ',
            text:err.message    
          }) 
        }, () => {
          console.log('completed ');
        })
       }else {
        Swal.fire({
          icon: 'error',
          title: 'خطأ',
          text:"بالرجاء التأكد من ملئ جميع الحقول"   
        })
        this.newsForm.markAllAsTouched();
        this.button = false;
       }
      }
      ngOnDestroy(){
        this._NewsService.Data.next(null);
         }
      
}
function removeItem(item: any, selectedItems: any) {
  throw new Error('Function not implemented.');
}

